import React from 'react';
import SEO from '../components/SEO';

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '40px 40px',
    fontFamily: '"Times New Roman", Times, serif',
    lineHeight: '1.6',
    color: '#333',
    backgroundColor: '#fff',
    paddingTop: '40px',
  },
  heading: {
    fontSize: '28px',
    fontWeight: '400',
    margin: '0 0 20px 0',
    letterSpacing: '1px',
    color: '#333',
    fontFamily: '"Times New Roman", Times, serif',
    textAlign: 'left',
  },
  subHeading: {
    fontSize: '18px',
    fontWeight: '400',
    margin: '40px 0 15px 0',
    color: '#333',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontFamily: '"Times New Roman", Times, serif',
  },
  text: {
    fontSize: '16px',
    color: '#333',
    lineHeight: '1.6',
    marginBottom: '20px',
    fontFamily: '"Times New Roman", Times, serif',
  },
  highlight: {
    border: '1px solid #ccc',
    padding: '20px',
    marginBottom: '30px',
    backgroundColor: '#fff',
  },
};

function CompanyInformation() {
  return (
    <div style={styles.container}>
      <SEO
        title="Company Information and Insights - Sapienta VC"
        description="Learn about Sapienta Venture Capital, our team, investment approach, and insights on the venture capital industry."
        keywords="sapienta vc, venture capital firm, company information, investment team, VC insights"
        url="https://sapienta.vc/company-information"
      />

      <p style={styles.text}>
        Founded in 2016, Sapienta Venture Capital has established itself as a leading investor in transformative
        technology companies. We operate as a founder-driven group with a portfolio of ambitious projects
        across payment innovation, artificial intelligence, and cutting-edge technology.
      </p>

      <h2 style={styles.subHeading}>Our Story</h2>

      <p style={styles.text}>
        Sapienta was born from the belief that exceptional technology can create lasting positive impact.
        Our founders recognized the need for a venture capital firm that thinks beyond short-term profits
        and takes a stand for everyday partners and investors.
      </p>

      <p style={styles.text}>
        Since inception, we have focused on building meaningful relationships with entrepreneurs who share
        our vision of leveraging technology to solve real-world problems. Our approach combines strategic
        capital with hands-on guidance to help portfolio companies achieve accelerated growth and market leadership.
      </p>


      <h2 style={styles.subHeading}>Investment Approach</h2>

      <div style={styles.highlight}>
        <h3 style={{...styles.subHeading, margin: '0 0 15px 0', fontSize: '16px'}}>Payment Innovation</h3>
        <p style={styles.text}>
          We focus on companies revolutionizing financial transactions and payment systems,
          from digital payment platforms to cryptocurrency and blockchain-based solutions.
        </p>
      </div>

      <div style={styles.highlight}>
        <h3 style={{...styles.subHeading, margin: '0 0 15px 0', fontSize: '16px'}}>Technology Excellence</h3>
        <p style={styles.text}>
          Our investments span cutting-edge technology companies building infrastructure for the future,
          including developer tools, cloud computing, and enterprise software solutions.
        </p>
      </div>

      <div style={styles.highlight}>
        <h3 style={{...styles.subHeading, margin: '0 0 15px 0', fontSize: '16px'}}>AI-Driven Solutions</h3>
        <p style={styles.text}>
          We back companies leveraging artificial intelligence and machine learning to transform industries,
          from autonomous systems to intelligent automation platforms.
        </p>
      </div>

      <h2 style={styles.subHeading}>Market Insights</h2>

      <p style={styles.text}>
        The venture capital landscape continues to evolve rapidly, with increasing focus on sustainable
        business models and technologies that create genuine value. We observe several key trends:
      </p>

      <p style={styles.text}>
        <strong>AI Integration:</strong> Artificial intelligence is becoming deeply embedded across industries,
        creating opportunities for companies that can deliver practical, scalable AI solutions.
      </p>

      <p style={styles.text}>
        <strong>Payment Evolution:</strong> The shift toward digital payments and embedded finance continues
        to accelerate, driven by changing consumer behavior and regulatory support.
      </p>

      <p style={styles.text}>
        <strong>Infrastructure Innovation:</strong> Developer tools and cloud infrastructure remain critical
        enablers of technological advancement across all sectors.
      </p>

      <h2 style={styles.subHeading}>Partnership Philosophy</h2>

      <p style={styles.text}>
        At Sapienta, we believe in building long-term partnerships with exceptional founders. Our approach
        goes beyond capital provision to include:
      </p>

      <p style={styles.text}>
        Strategic guidance based on our extensive network and industry experience, hands-on support during
        critical growth phases, and access to our portfolio ecosystem for cross-company collaboration and learning.
      </p>

      <p style={styles.text}>
        We prioritize sustainable growth and long-term success over short-term gains, empowering our portfolio
        companies to thrive in ever-evolving markets while maintaining strong unit economics and viable paths to profitability.
      </p>

      <h2 style={styles.subHeading}>Contact Information</h2>

      <p style={styles.text}>
        For partnership inquiries, company information, or investment opportunities,
        contact us at <a href="mailto:info@sapienta.vc" style={{color: '#666', textDecoration: 'underline'}}>info@sapienta.vc</a>
      </p>
    </div>
  );
}

export default CompanyInformation;